var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeriesEpisode01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Series &amp;amp; Episode") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.81,
    y: 1,
    width: 22.38,
    height: 19.02,
    rx: 4.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.12,
    y1: 15.38,
    x2: 23.17,
    y2: 15.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.63,
    y1: 20.16,
    x2: 8.98,
    y2: 22.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.44,
    y1: 20.16,
    x2: 14.92,
    y2: 22.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.71,
    y1: 23.31,
    x2: 17.36,
    y2: 23.31
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.2 11.5 10.2 5.49 15.02 8.43 10.2 11.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeriesEpisode01);
export default __webpack_public_path__ + "static/media/Series_Episode_01.752511dbbe134d330465bea5360be8a5.svg";
export { ForwardRef as ReactComponent };